import React from "react";

import NewInSlice from "../../components/slices/newIn/NewInSlice";

const NewIn = ({ slice }) => {
  return <NewInSlice slice={slice} />;
};

export default NewIn;
